import * as types from "@/store/constants/types";
export default {
  [types.RECEIVE_INS_USER_MEDIA_LIST_DATA](state: any, payLoad: any) {
    const { userId, insUserMedia } = payLoad;
    const mediaListLength = insUserMedia.items.length;
    const mediaItem = state.insUserMediaList.find((item: any) => {
      return item.userId.toString() === userId.toString();
    });
    console.log(mediaItem)
    if (mediaItem === undefined || mediaItem === null) {
      state.insUserMediaList.push({
        userId,
        insMediaList: insUserMedia.items,
        maxMediaId: mediaListLength === 0 ? null : insUserMedia.next_max_id,
        moreAvaliable: insUserMedia.more_available,
        dataStatus: "ready"
      });
    } else {
      mediaItem.insMediaList = insUserMedia.items;
      mediaItem.maxMediaId =
        mediaListLength === 0 ? null : insUserMedia.next_max_id;
      mediaItem.moreAvaliable = insUserMedia.more_available;
      mediaItem.dataStatus !== "ready"
        ? (mediaItem.dataStatus = "ready")
        : void 3;
    }
    console.log(state.insUserMediaList)
  },
  [types.RECEIVE_INS_USER_MEDIA_LIST_DATA_MORE](state: any, payLoad: any) {
    const { userId, insUserMedia } = payLoad;
    const mediaListLength = insUserMedia.items.length;
    const mediaItem = state.insUserMediaList.find((item: any) => {
      return item.userId === userId;
    });
    const findIndex = state.insUserMediaList.findIndex((item: any) => {
      return item.userId === userId;
    });
    if (mediaItem !== undefined) {
      mediaItem.maxMediaId =
        mediaListLength === 0 ? null : insUserMedia.next_max_id;
      mediaItem.moreAvaliable = insUserMedia.more_available;
      mediaItem.insMediaList = [
        ...mediaItem.insMediaList,
        ...insUserMedia.items
      ];
      state.insUserMediaList.splice(findIndex, 1, mediaItem);
    }
  },
  [types.UPDATE_POST_DISABLE_COMMENT](state: any, payLoad: any) {
    const { mediaId, userId } = payLoad;
    //获取单个的post信息，让comments_disabled变为false
    const mediaItem = state.insUserMediaList.find((item: any) => {
      return item.userId.toString() === userId.toString();
    });
    if (mediaItem !== undefined) {
      const { insMediaList } = mediaItem;
      const findMeida = insMediaList.find((media: any) => {
        return media.id === mediaId;
      });
      if (findMeida !== undefined) {
        findMeida.hasOwnProperty("comments_disabled")
          ? (findMeida.comments_disabled = false)
          : void 0;
      }
    }
  }
};
